// extracted by mini-css-extract-plugin
export default {"calcbtn":"Buttons_calcbtn__NYzyl","clearbtn":"Buttons_clearbtn__x0asU","boxbtn":"Buttons_boxbtn__P7BJV"};